import React, { useState } from "react";
import "./ReportData.css";

function Category({setTypeData , typeData}) {
  return (
    <div className="main-data-1">
      <div className="category">
        <p>Transaction Type :-</p>
      </div>
      <div className="category">
        <span>Pay In</span>
        <input
          type="checkbox"
          checked={typeData == "Payin" ? true : false}
          name="Payin"
          onChange={(e) => {
            typeData == "Payin"
              ? setTypeData("")
              : setTypeData(e.target.name);
          }}
        />
      </div>

      <div className="category">
      <span>Pay Out</span>
        <input
          type="checkbox"
          name="Payout"
          checked={typeData == "Payout" ? true : false}
          onChange={(e) => {
            typeData == "Payout"
              ? setTypeData("")
              : setTypeData(e.target.name);
          }}
        />
      </div>

      {/* <div className="category">
        <p>Rolling Reserve</p>
        <input type="checkbox" disabled={true} />
      </div> */}
    </div>
  );
}

export default Category;